import mixpanel from 'mixpanel-browser';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { BuildADashTrackingEvents } from '@revelio/core';

import { AIAssistantFAB } from '../CustomDash/components/AIAssistant/AIAssistantFAB';
import { GLOBAL_AI_FAB_RIGHT_PX } from '../CustomDash/constants/panelWidths';
import { GlobalAIAssistantChartPreviewShell } from './global-ai-assistant-chart-preview-shell';
import { useGlobalAIAssistant } from './global-ai-assistant-context';
import { GlobalAIAssistantDrawer } from './global-ai-assistant-drawer';
import { shouldHideGlobalAIAssistantForPathname } from './global-ai-assistant-visibility';
import { GlobalAiHeadlessDigestHost } from './headless-digest/global-ai-headless-digest-host';
import { useGlobalAIAssistantFeatureEnabled } from './use-global-ai-assistant-feature-enabled';

export function GlobalAIAssistantHost() {
  const enabled = useGlobalAIAssistantFeatureEnabled();
  const { pathname } = useLocation();
  const { openDrawer, closeDrawer, isDrawerOpen } = useGlobalAIAssistant();
  const isHiddenPath = shouldHideGlobalAIAssistantForPathname(pathname);

  useEffect(() => {
    if (isHiddenPath && isDrawerOpen) {
      closeDrawer();
    }
  }, [isHiddenPath, isDrawerOpen, closeDrawer]);

  if (!enabled) {
    return null;
  }

  if (isHiddenPath) {
    return null;
  }

  return (
    <>
      <GlobalAIAssistantChartPreviewShell />
      <GlobalAiHeadlessDigestHost />
      <AIAssistantFAB
        isVisible
        fixedRightPx={GLOBAL_AI_FAB_RIGHT_PX}
        tooltipLabel={isDrawerOpen ? 'Close AI chat' : 'Open AI chat'}
        aria-label={isDrawerOpen ? 'Close AI chat' : 'Open AI chat'}
        onClick={() => {
          if (isDrawerOpen) {
            closeDrawer();
            return;
          }
          mixpanel.track(BuildADashTrackingEvents.GLOBAL_AI_ASSISTANT_OPEN);
          openDrawer();
        }}
      />
      {isDrawerOpen ? <GlobalAIAssistantDrawer /> : null}
    </>
  );
}
